module.exports = __webpack_public_path__ + "img/ic_checked.1784da72.png";